import React, { useState, useEffect, useRef, useCallback } from 'react';
import styled from 'styled-components/macro';

import useScrollStore from '../../common/store/useScrollStore';
import useModalStore from './useModalStore';
import useAnimation from './useAnimation';
import Header from './Header';
import Body from './Body';
import Footer from './Footer';

const Mask = styled.div`
  position: absolute;
  z-index: 30;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;

  background: #0007;

  opacity: 0;
  display: none;
  align-items: center;
  justify-content: center;
`;

const Container = styled.div`
  width: 90%;
  max-width: 600rem;
  max-height: 80%;

  overflow: hidden;
  border-radius: 10rem;
  background: #f5f5f5;

  display: flex;
  flex-direction: column;
`;

const Disclaimer = () => {
  const setOpen = useModalStore(useCallback(state => state.setOpen, []));
  const setClose = useModalStore(useCallback(state => state.setClose, []));

  const lockScroll = useScrollStore(useCallback(state => state.lockScroll, []));
  const unlockScroll = useScrollStore(useCallback(state => state.unlockScroll, []));

  const ref = useRef<HTMLDivElement>(null);
  const [display, setDisplay] = useState(false);

  useAnimation(ref, display);

  const openModal = () => {
    setDisplay(true);
    lockScroll();
  }

  const closeModal = () => {
    setDisplay(false);
    unlockScroll();
  }

  useEffect(() => {
    setOpen(openModal);
    setClose(closeModal);

    return () => {
      setOpen(null);
      setClose(null);
      setDisplay(false);
    }
  }, []);

  return (
    <Mask
      ref={ref}
      onClick={closeModal}
    >
      <Container onClick={e => e.stopPropagation()}>
        <Header />
        <Body />
        <Footer />
      </Container>
    </Mask>
  );
}

export default Disclaimer;